/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppSecretPasswordValidationResultMetadata } from './AppSecretPasswordValidationResultMetadata';
import {
    AppSecretPasswordValidationResultMetadataFromJSON,
    AppSecretPasswordValidationResultMetadataFromJSONTyped,
    AppSecretPasswordValidationResultMetadataToJSON,
} from './AppSecretPasswordValidationResultMetadata';

/**
 * 
 * @export
 * @interface AppSecretPasswordValidationResult
 */
export interface AppSecretPasswordValidationResult {
    /**
     * 
     * @type {boolean}
     * @memberof AppSecretPasswordValidationResult
     */
    password_valid: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppSecretPasswordValidationResult
     */
    error_message: string;
    /**
     * 
     * @type {AppSecretPasswordValidationResultMetadata}
     * @memberof AppSecretPasswordValidationResult
     */
    metadata: AppSecretPasswordValidationResultMetadata | null;
}

/**
 * Check if a given object implements the AppSecretPasswordValidationResult interface.
 */
export function instanceOfAppSecretPasswordValidationResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password_valid" in value;
    isInstance = isInstance && "error_message" in value;
    isInstance = isInstance && "metadata" in value;

    return isInstance;
}

export function AppSecretPasswordValidationResultFromJSON(json: any): AppSecretPasswordValidationResult {
    return AppSecretPasswordValidationResultFromJSONTyped(json, false);
}

export function AppSecretPasswordValidationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppSecretPasswordValidationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password_valid': json['password_valid'],
        'error_message': json['error_message'],
        'metadata': AppSecretPasswordValidationResultMetadataFromJSON(json['metadata']),
    };
}

export function AppSecretPasswordValidationResultToJSON(value?: AppSecretPasswordValidationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password_valid': value.password_valid,
        'error_message': value.error_message,
        'metadata': AppSecretPasswordValidationResultMetadataToJSON(value.metadata),
    };
}

